import { Component, ElementRef, Inject, Optional, ViewChild, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApplicationSearchService } from '@lmc-app/core/services/application-search.service';
import { ListenerService } from '@lmc-app/core/services/listener.service';

interface SearchHistoryItem {
  deal_name: string;
  summary_link?: string;
}

@Component({
  selector: 'app-search-modal',
  templateUrl: './search-modal.component.html',
  styleUrls: ['./search-modal.component.scss']
})
export class SearchModalComponent implements AfterViewInit {
  protected pageHistoryArray: SearchHistoryItem[] = [];
  protected searchKeyword: string;
  protected tooltipShowDelay = 0;
  protected tooltipHideDelay = 2000;
  protected isDropdownOpen = false;

  @ViewChild('searchBarInput') private searchBarInput: ElementRef;

  constructor(
    private _appSearchService: ApplicationSearchService,
    private _listenerService: ListenerService, 
    private router: Router,
    public dialogRef: MatDialogRef<SearchModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: { globalSearchParam: string, searchKeyword: string, pageHistoryArray: any, trigger: ElementRef },
  ) { }

  ngOnInit() {
    const matDialogConfig: MatDialogConfig = new MatDialogConfig();
    const rect = this.data.trigger.nativeElement.getBoundingClientRect();
    matDialogConfig.position = { right: `${window.innerWidth - rect.right - 50}px`, top: `${rect.top - 10}px` };
    this.dialogRef.updatePosition(matDialogConfig.position);
    this.pageHistoryArray = this.data.pageHistoryArray;
    this.searchKeyword = this.data.searchKeyword;
  }

  ngAfterViewInit() {
    setTimeout(() => this.searchBarInput.nativeElement.focus(), 0);
  }

  openSearchDropdown(): void {
    this.isDropdownOpen = true;
  }

  closeSearchDropdown(): void {
    this.isDropdownOpen = false;
  }

  onSearchKeywordChange(evt: KeyboardEvent) {
    if (evt.key === 'Enter') {
      const target = evt.target as HTMLInputElement;
      this.router.navigate(['dashboard'], {
        queryParams: {
          searchKeyword: this.searchKeyword.trim() || target.value.trim(),
        },
      });
      this.closeSearchDropdown();
      this.closeModal();
    }
  }

  onSearchClicked() {
    this.router.navigate(['dashboard'], {
      queryParams: {
        searchKeyword: this.searchKeyword.trim(),
      },
    });
    this.closeSearchDropdown();
    this.closeModal();
  }

  selectSearchParameter(param: string): void {
    setTimeout(() => this.searchBarInput.nativeElement.focus(), 0);
  }

  closeModal() {
    this.dialogRef.close(false);
  }

  getRowStyle() {
    return { cursor: 'pointer' };
  }

  onSearchItem(item: SearchHistoryItem) {
    this.closeSearchDropdown();
    if (!item?.summary_link) {
      console.warn('No link on name', item);
      return;
    }
    this.router.navigate([item.summary_link]);
    this.closeSearchDropdown();
    this.closeModal();
  }

  onClearHistory(){
    const userEmail = this.data?.['userEmail'];
    if (!userEmail) {
      console.warn('No user found', userEmail);
      return;
    }

    this._appSearchService.deleteUserPageHistory(userEmail).subscribe({
      next: (response) => {
        console.log('Deleted:', response);
        this._listenerService.emit('clearedPageHistories', true);
        console.log('cleared, current value:', this.pageHistoryArray, 'length:', this.pageHistoryArray.length);
        this.closeSearchDropdown();
        this.closeModal();
      },
      error: (err) => {
        if (err.status === 404) {
          console.warn('User application histories was already deleted or does not exist');
        } else {
          console.error('Delete failed', err);
        }
      }
    });
  }
}